import styled from 'styled-components';

import { Divider, GridLegacy as Grid } from '@mui/material';

export const BackgroundInformationSections = styled.div`
  position: relative;
  overflow-y: scroll;

  & {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const StyledRowTitle = styled.p`
  font-size: 14px;
  color: ${({ theme }) => theme.palette.text.secondary};
  margin-right: 14px;
`;

export const SectionContainer = styled.div`
  display: flex;
  flex: 1;
  padding: 24px;
`;

export const SectionHeader = styled(Grid)`
  display: flex;
  justify-content: center;
  margin-bottom: 8px;
  margin-top: 16px;
  background: ${({ theme }) => theme.palette.primary.light};
  border-radius: 5px;
  height: 29px;
  p {
    color: ${({ theme }) => theme.palette.primary.main};
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 160%;
    letter-spacing: 0.15px;
    margin: 0px;
  }
`;

export const RowWrapper = styled.div`
  width: 100%;
`;

export const RowContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 8px;
`;

export const StyledDivider = styled(Divider)`
  margin-top: 7px;
`;
